import React from 'react';
import Toast from 'react-bootstrap/Toast';
import { useDispatch, useSelector } from 'react-redux';
import { removeNotificationById } from './toastNotificationSlice';
import { getEpochTimeInSecond } from './toastNotificationHelper';

const containerStyle = {
  position: 'fixed',
  top: 0,
  right: 0,
  minWidth: 270,
  zIndex: 1000,
} as React.CSSProperties;

const ToastNotification = () => {
  const dispatch = useDispatch<AppDispatch>();
  const toastNotificationData = useSelector((state: RootState) => state.toastNotification.data);
  const toasts = toastNotificationData.latestData || [];
  const now = getEpochTimeInSecond();

  return (
    <div style={containerStyle}>
      {toasts.map((item, index) => {
        const timeText = item?.epochTimeInSec
          ? `${now - item.epochTimeInSec} second(s) ago`
          : 'a moment ago';
        return (
          <Toast
            key={item?.id || `toast-${index}-${item?.message || ''}`}
            animation
            autohide
            className={`notification-wrapper ${item?.warning ? 'bg-danger' : ''}`}
            delay={item?.delayTime || 3000}
            show
            style={{ marginBottom: 12, minWidth: 270 }}
            onClose={() => dispatch(removeNotificationById(item?.id))}
          >
            <Toast.Header>
              <strong>{item?.title || 'Message'}</strong>
              <small className="time">{timeText}</small>
            </Toast.Header>
            <Toast.Body style={{ whiteSpace: 'pre-line' }}>{item?.message || ''}</Toast.Body>
          </Toast>
        );
      })}
    </div>
  );
};

export default ToastNotification;
